import { useRouter } from '@v2/commons/utils/navigation'
import { DEFAULT_ROUTES } from '@v2/domains/routing/types/routing.types'
import { getRoutePath } from '@v2/domains/routing/utils/route.utils'
import { selectPolicies } from '@v2/domains/user/selectors/user.selectors'
import { useAppSelector } from '@v2/store/hooks'

export const TeamLeadHubHook = () => {
  const router = useRouter()

  const policies = useAppSelector(selectPolicies)

  const handleClinics = () => {
    router.push(`${getRoutePath(DEFAULT_ROUTES.LOCATIONS)}`)
  }

  const isEnableClinics = policies.some(
    (policie) => policie === 'is_clinics_enabled',
  )

  return {
    handleClinics,
    isEnableClinics,
  }
}
